import * as yup from "yup";

import { DARK, LIGHT } from "constants/appModes";

const colorRegex = /^#([A-Fa-f0-9]{6})$/;
const colorString = yup
  .string()
  .required()
  .matches(colorRegex, "Primary color must be a hex color like #RRGGBB.");
const themeObject = yup
  .object({
    name: yup.string().required().label("Theme name"),
    primary: colorString,
    gradient: yup.array().of(colorString),
  })
  .required();

export const createAppThemeValidator = yup.object({
  name: yup.string().required().label("Customization name"),
  [LIGHT]: themeObject,
  [DARK]: themeObject,
});
